// Number tag (UX spec 3.3): an 8 px square swatch in the number's hue beside its label. The swatch is
// decorative; the label carries the meaning, so colour is never the only cue.
import { numberTagLabel, tagHueFor } from '../lib/numberTags.ts';

export function TagSwatch({ numberId }: { numberId: string }) {
  return <span className={`tag-swatch tag-${tagHueFor(numberId)}`} aria-hidden="true" />;
}

export function NumberTag({ number }: { number: { id: string; label?: string | null } }) {
  return (
    <span className="number-tag">
      <TagSwatch numberId={number.id} />
      <span className="number-tag-label">{numberTagLabel(number)}</span>
    </span>
  );
}
